<template>
  <modal
    v-model="open"
    :title="$t('DELETE_ASSET_MODAL_TITLE')"
    @hide="closeModal"
  >
    <div v-if="getReferencesStatus.status !== 'pending'">
      <p
        v-if="assetReferences && !assetReferences.hasReferences"
        v-t="'DELETE_ASSET_MODAL_ASSET_NONE_ASSOCIATION_TEXT'"
      />
      <div v-if="assetReferences && assetReferences.hasReferences">
        <p
          v-html="
            $t('DELETE_ASSET_MODAL_ASSET_ASSOCIATION_TEXT', { assetName })
          "
        />

        <div class="well well-sm m-t-10 m-b-0">
          <div class="form-horizontal">
            <div
              v-if="assetReferences.ivrtrees && assetReferences.ivrtrees.length"
              class="row"
            >
              <label class="col-md-3 control-label">
                <strong>IVR Trees</strong>
              </label>
              <div class="col-md-8">
                <ul
                  class="list-unstyled form-control-static list-text-overflow"
                >
                  <li
                    v-for="ivrTree in assetReferences.ivrtrees"
                    :key="ivrTree.ivrtreeId"
                  >
                    <a
                      rel="noopener"
                      target="_blank"
                      href="javascript:;"
                      class="table-ellipsis__name linked-name"
                      @click.prevent="goToIvrTree(ivrTree.ivrtreeId)"
                    >
                      <span
                        class="display-text"
                        :title="ivrTree.ivrtreeName"
                      >
                        {{ ivrTree.ivrtreeName }}
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="getReferencesStatus.status == 'pending'"
    >
      <Loader />
      <span v-t="'ASSETS_REFERENCES_LOADING'" />
    </div>
    <div slot="footer">
      <button
        v-t="'DELETE'"
        :disabled="deleteButtonDisabled"
        type="button"
        class="btn btn-primary"
        @click="removeAsset()"
      />
      <button
        v-t="'CANCEL'"
        type="button"
        class="btn btn-danger"
        @click="closeModal()"
      />
    </div>
  </modal>
</template>

<script>
import { mapState } from 'vuex';
import messages from '../locales';
import Loader from '@/core/components/Loader';
import { $ngStateService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { getStatus } from '@/store/helpers';

export default {
  components: {
    Loader,
  },
  props: {
    showModal: {
      type: Boolean,
      default() {
        return false;
      },
    },
    assetId: {
      type: String,
      default() {
        return '';
      },
    },
    assetName: {
      type: String,
      default() {
        return '';
      },
    },
  },
  data: function () {
    return {
      open: this.showModal,
    };
  },
  computed: {
    ...mapState('assets', ['assetReferences']),
    ...mapState('assets', {
      getReferencesStatus: (state) => getStatus(state, 'getAssetReferences') || {},
    }),
    deleteButtonDisabled() {
      return (
        this.getReferencesStatus.status === 'pending' ||
        this.assetReferences &&
        this.assetReferences.hasReferences
      );
    },
  },
  watch: {
    showModal: function (newVal) {
      // watch it
      this.open = newVal;
    },
  },
  methods: {
    closeModal() {
      this.$emit('hide-modal');
    },
    removeAsset() {
      this.$emit('remove-asset');
    },
    goToIvrTree(id) {
      $ngStateService.go('dashboard.ivr.edit', {
        treeId: id
      });
    }
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>

<style>
</style>